import { createApp } from "vue";
import store from "../../common/js/store";
import registerServiceWorker from "./serviceWorkerRegistration";

// Global components import
import LocationPage from "../../common/js/components/LocationPage.vue";
import LocationNotFound from "../../common/js/components/LocationNotFound.vue";
import InitializeLocation from "../../common/js/components/InitializeLocation.vue";
import ToastMsg from "../../common/js/components/ToastMsg.vue";
import Loader from "../../common/js/components/Loader.vue";
import MiniLogin from "../../common/js/components/MiniLogin.vue";
import AddEditAddressForm from "../../common/js/components/AddEditAddressForm.vue";
import LocationPermissionPopup from "../../common/js/components/LocationPermissionPopup.vue";
import LocationAccessBlockedMessage from "../../common/js/components/LocationAccessBlockedMessage.vue";
import Ripple from "../../common/js/helpers/ripple";

const app = createApp({});
app.use(store);

// Global components registration
// @todo: similarly all other components registration currently inside Home.vue will move here and Home.vue will be discarded
app.directive("ripple", Ripple);
app.component("location-page", LocationPage);
app.component("location-not-found", LocationNotFound);
app.component("initialize-location", InitializeLocation);
app.component("toast-msg", ToastMsg);
app.component("loader", Loader);
app.component("mini-login", MiniLogin);
app.component("add-edit-address-form", AddEditAddressForm);
app.component("location-permission-popup", LocationPermissionPopup);
app.component("location-access-blocked-message", LocationAccessBlockedMessage);

app.mount("#themeDefaultLocation");

// @todo : uncomment this...

registerServiceWorker();

if (typeof window != "undefined") {
  window.onbeforeunload = () => {
    window.scrollTo(0, 0);
  };
}
